// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.PaymentSettingsModal_dashboard__ExtGN {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.PaymentSettingsModal_dashboardContain__iDUjH {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_dashboardContain__iDUjH,
.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_dashboard__ExtGN,
.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_cont2__D2bFX {
  background-Color: #0f1824;
}

.PaymentSettingsModal_top_header__aGudw .PaymentSettingsModal_top_header_inner__1Yhqp {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.PaymentSettingsModal_cont2__D2bFX {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.PaymentSettingsModal_subLink__JJXbl svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.PaymentSettingsModal_cst_vendr__kqJjx input {
  min-height: 35px !important;
}

.PaymentSettingsModal_cst_vendr__kqJjx .PaymentSettingsModal_form-control__N53Pk {
  background-color: #f5f6fa;
  border: none;
}

.PaymentSettingsModal_footer__UUI8l {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.PaymentSettingsModal_bodythemelight__384-z {
  background-color: #fff;
  padding-top: 90px;
}

.PaymentSettingsModal_bodythemedark__BqfuP {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.PaymentSettingsModal_headerthemelight__mN\\+tN {
  background-color: #fff;
}

.PaymentSettingsModal_headerthemedark__Uomh1 {
  background-color: #132337;
}

.PaymentSettingsModal_top_header__aGudw {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.PaymentSettingsModal_menuthemelight__\\+XwHr {
  background-color: #fff;
}

.PaymentSettingsModal_menuthemedark__TeoKy {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.PaymentSettingsModal_menulinklight__WdDYG span {
  color: #666666 !important;
}

.PaymentSettingsModal_menulinklight__WdDYG a {
  color: #CBCBCB !important;
}

.PaymentSettingsModal_menulinklight__WdDYG:hover span,
.PaymentSettingsModal_menulinklight__WdDYG:hover a {
  color: #fff !important;
}

.PaymentSettingsModal_menulinkdarkSelected__RqArc {
  background-color: #1c2e45;
  color: #3b82f6;
}

.PaymentSettingsModal_menuthemelight__\\+XwHr .PaymentSettingsModal_menulinklightSelected__k06O8 {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.PaymentSettingsModal_menulinkdark__Uwqd\\+ {
  color: #92afd3 !important;
}

.PaymentSettingsModal_menulinklight__WdDYG:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.PaymentSettingsModal_menulinklight__WdDYG .PaymentSettingsModal_sub_arrow__uJL0A svg path {
  stroke: #CBCBCB !important;
}

.PaymentSettingsModal_menulinklight__WdDYG:hover .PaymentSettingsModal_sub_arrow__uJL0A svg path {
  stroke: #fff !important;
}

.PaymentSettingsModal_menulinkdark__Uwqd\\+ .PaymentSettingsModal_sub_arrow__uJL0A svg path {
  stroke: #92afd3 !important;
}

.PaymentSettingsModal_menulinkdark__Uwqd\\+:hover .PaymentSettingsModal_sub_arrow__uJL0A svg path {
  stroke: #fff !important;
}

.PaymentSettingsModal_menulinklight__WdDYG:hover svg path,
.PaymentSettingsModal_menulinklightSelected__k06O8 svg path {
  fill: #fff !important;
}

.PaymentSettingsModal_menulinkdark__Uwqd\\+:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.PaymentSettingsModal_headinglight__bSHB4 {
  color: #60677e;
}

.PaymentSettingsModal_headingdark__3w32M {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.PaymentSettingsModal_searchboxlight__5-M3g {
  background-color: #fff;
  border: none;
}

.PaymentSettingsModal_searchboxdark__RzjOr {
  background-color: #132337;
  color: #fff;
  border: none;
}

.PaymentSettingsModal_searchboxdark__RzjOr::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.PaymentSettingsModal_tableheadlight__VlNTb {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.PaymentSettingsModal_tableheadlight__VlNTb th {
  color: #fff;
}

thead .PaymentSettingsModal_tableheadlight__VlNTb th:first-child,
thead .PaymentSettingsModal_tableheaddark__6hydC th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .PaymentSettingsModal_tableheadlight__VlNTb th:last-child,
thead .PaymentSettingsModal_tableheaddark__6hydC th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.PaymentSettingsModal_table__Z04HS.PaymentSettingsModal_table-borderless__BZyTT {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.PaymentSettingsModal_tableheaddark__6hydC {
  background-color: #132337;
  color: #fff;
}

.PaymentSettingsModal_table-borderless__BZyTT tr:nth-child(even) {
  background-color: #F9FAFB;
}

.PaymentSettingsModal_table-borderless__BZyTT .PaymentSettingsModal_left-section__Sn21M {
  padding-top: 10px;
}

.PaymentSettingsModal_tablebodylight__5TDgV td,
.PaymentSettingsModal_tablebodydark__jT8wN td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.PaymentSettingsModal_tablebodylight__5TDgV {
  background-color: #fff;
}
.PaymentSettingsModal_tablebodylight__5TDgV:hover {
  background-color: #fff;
  cursor: auto;
}

.PaymentSettingsModal_tablebodydark__jT8wN {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.PaymentSettingsModal_tablebodydark__jT8wN:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.PaymentSettingsModal_paginationlight__9UACm {
  color: #60677e !important;
  font-size: 13px !important;
}

.PaymentSettingsModal_paginationdark__t-1Vw {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.PaymentSettingsModal_formthemelight__y9Tlf {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.PaymentSettingsModal_formthemedark__Wo69v {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.PaymentSettingsModal_formthemedark__Wo69v ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.PaymentSettingsModal_viewformlight__zESmO {
  background-color: #f3f6f9;
}

.PaymentSettingsModal_permissionboxlight__JyrrY {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.PaymentSettingsModal_permissionboxdark__xFd\\+e {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.PaymentSettingsModal_errormsgclr__nLUYj {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.PaymentSettingsModal_graphclrlight__4-Wme {
  background-color: #fff;
}

.PaymentSettingsModal_graphclrdark__sgQ-Q {
  background-color: #132337;
}

/* 
Counter theme
*/
#PaymentSettingsModal_card1bglight__6gBl\\+ {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#PaymentSettingsModal_card1bgdark__BdQlZ {
  background: #392f28;
}

#PaymentSettingsModal_card2bglight__Qe-1- {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#PaymentSettingsModal_card2bgdark__BdXve {
  background: #1c3238;
}

#PaymentSettingsModal_card3bglight__7llzU {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#PaymentSettingsModal_card3bgdark__JQDS7 {
  background: #3a2434;
}

#PaymentSettingsModal_card4bglight__aFAj7 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#PaymentSettingsModal_card4bgdark__Whge2 {
  background: #2f264f;
}

#PaymentSettingsModal_card1bgdark__BdQlZ a,
#PaymentSettingsModal_card1bgdark__BdQlZ p,
#PaymentSettingsModal_card2bgdark__BdXve a,
#PaymentSettingsModal_card2bgdark__BdXve p,
#PaymentSettingsModal_card3bgdark__JQDS7 a,
#PaymentSettingsModal_card3bgdark__JQDS7 p,
#PaymentSettingsModal_card4bgdark__Whge2 a,
#PaymentSettingsModal_card4bgdark__Whge2 p {
  color: #fff;
}

/* 
Action button theme
*/
.PaymentSettingsModal_actionbtnlight__KbI9t {
  color: rgba(70, 71, 91, 0.8705882353);
}

.PaymentSettingsModal_actionbtndark__NtzPb {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.PaymentSettingsModal_profiledropdownlight__Hq7sB {
  background-color: #fff;
}

.PaymentSettingsModal_profiledropdowndark__BdIVp {
  background-color: #151521;
}

.PaymentSettingsModal_settingsection__kTl2n #PaymentSettingsModal_addform__573sC.PaymentSettingsModal_formthemedark__Wo69v .PaymentSettingsModal_savebtn__Sh0QS {
  background-color: #3b82f6;
  color: #fff;
}

#PaymentSettingsModal_addform__573sC.PaymentSettingsModal_formthemedark__Wo69v .PaymentSettingsModal_savebtn__Sh0QS {
  background-color: #3b82f6;
  color: #fff;
}

.PaymentSettingsModal_profile_conatiner__Q8Uf9 {
  border-radius: 5px !important;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_ag-theme-alpine__kvTyN .PaymentSettingsModal_ag-row__z3z4g {
  background: #000 !important;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_formbtn__0B-Wt {
  background-color: #3b82f6;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_formbtn__0B-Wt:hover {
  background-color: #2563eb;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_resetbtn__zuy58 {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.PaymentSettingsModal_headingdark__3w32M span {
  background-color: #132337;
}

.PaymentSettingsModal_resetbtn__zuy58 {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.PaymentSettingsModal_resetbtn__zuy58:hover,
.PaymentSettingsModal_resetbtn__zuy58:active,
.PaymentSettingsModal_resetbtn__zuy58:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.PaymentSettingsModal_addBtn__LPsK9 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.PaymentSettingsModal_addDltBtn__H2Ndi {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.PaymentSettingsModal_addbtnlight__HAy0U {
  background-color: #38A169;
}

.PaymentSettingsModal_addbtndark__6uMpR {
  background-color: #3b82f6;
}

.PaymentSettingsModal_addbtndark__6uMpR:hover {
  background-color: #2563eb;
}

.PaymentSettingsModal_formthemedark__Wo69v label {
  color: #92afd3;
}

.PaymentSettingsModal_addBtn__LPsK9 svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.PaymentSettingsModal_addBtn__LPsK9:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.PaymentSettingsModal_cust_addBtn__5ECU7.PaymentSettingsModal_addBtn__LPsK9 svg {
  top: 2px;
}

.PaymentSettingsModal_deleteBtn__pSY2c {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.PaymentSettingsModal_deleteBtn__pSY2c:active,
.PaymentSettingsModal_deleteBtn__pSY2c:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.PaymentSettingsModal_deleteBtn__pSY2c svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.PaymentSettingsModal_deleteBtn__pSY2c:hover,
.PaymentSettingsModal_deleteBtn__pSY2c:active,
.PaymentSettingsModal_deleteBtn__pSY2c:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.PaymentSettingsModal_confirmBtn__F5lQJ {
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  background-color: #131F43 !important;
}

.PaymentSettingsModal_confirmBtn__F5lQJ:active,
.PaymentSettingsModal_confirmBtn__F5lQJ:focus {
  background-color: #131F43 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.PaymentSettingsModal_confirmBtn__F5lQJ:hover,
.PaymentSettingsModal_confirmBtn__F5lQJ:active,
.PaymentSettingsModal_confirmBtn__F5lQJ:focus {
  background-color: #0f1824 !important;
}

.PaymentSettingsModal_confirmBtn__F5lQJ svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.PaymentSettingsModal_delPopContainer__7QEYf .PaymentSettingsModal_modal-body__3o6H5 {
  padding: 35px;
  text-align: center;
}

.PaymentSettingsModal_delPopContainer__7QEYf .PaymentSettingsModal_delet_icon__h55u6 {
  margin-bottom: 11px;
}

.PaymentSettingsModal_delPopContainer__7QEYf p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.PaymentSettingsModal_arrowback__YpR4a svg {
  fill: #000;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_arrowback__YpR4a {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_arrowback__YpR4a svg {
  fill: #3b82f6;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_drpdwn_btn__K0Wce {
  background-color: #132337;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_empname__UuWxP {
  color: #92afd3 !important;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_navitemli__E8MFD a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_tabnavli__d8-kP a.PaymentSettingsModal_settingsgeneral__AHXjP,
.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_tabnavli__d8-kP a.PaymentSettingsModal_settingslinks__VdaPM:hover {
  background-color: #3b82f6;
  color: #fff;
}

.PaymentSettingsModal_bodythemedark__BqfuP .PaymentSettingsModal_tabnavli__d8-kP a.PaymentSettingsModal_settingslinks__VdaPM {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.PaymentSettingsModal_headerthemedark__Uomh1 .PaymentSettingsModal_dropdown_menu_contain__HeODC {
  background-color: #1c2e45;
  color: #fff;
}

.PaymentSettingsModal_headerthemedark__Uomh1 .PaymentSettingsModal_dropdown_menu_contain__HeODC ul li a,
.PaymentSettingsModal_headerthemedark__Uomh1 .PaymentSettingsModal_dropdown_menu_contain__HeODC .PaymentSettingsModal_dropdown_item__vxXx8,
.PaymentSettingsModal_headerthemedark__Uomh1 .PaymentSettingsModal_dropdown_menu_contain__HeODC .PaymentSettingsModal_dropdown_item__vxXx8 h5 {
  color: #fff;
}

.PaymentSettingsModal_headerthemedark__Uomh1 .PaymentSettingsModal_dropdown_menu_contain__HeODC ul li a:hover,
.PaymentSettingsModal_headerthemedark__Uomh1 .PaymentSettingsModal_dropdown_menu_contain__HeODC .PaymentSettingsModal_dropdown_item__vxXx8:hover {
  background-color: #132337;
  color: #fff;
}

.PaymentSettingsModal_dropdown_item__vxXx8:active {
  background-color: #F5F6FA;
}

.PaymentSettingsModal_profile_arrrow_dwn__zMSXS {
  stroke: #132337;
}

.PaymentSettingsModal_headerthemedark__Uomh1 .PaymentSettingsModal_profile_arrrow_dwn__zMSXS {
  stroke: #fff;
}

.PaymentSettingsModal_dateinputbox1__SBNzJ input,
.PaymentSettingsModal_dateinputbox1__SBNzJ span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.PaymentSettingsModal_delPopContainer__7QEYf .PaymentSettingsModal_modal-content__bNvCT {
  border-radius: 10px;
  min-width: 399px;
}

.PaymentSettingsModal_larg_model__Pv6G2 .PaymentSettingsModal_modal-dialog__Zvdt\\+ {
  max-width: 100% !important;
}

.PaymentSettingsModal_larg_model__Pv6G2 .PaymentSettingsModal_modal-content__bNvCT {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.PaymentSettingsModal_larg_model__Pv6G2 .PaymentSettingsModal_modal-header__lDLsF {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .PaymentSettingsModal_btn-primary__oRX7t:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.PaymentSettingsModal_form-select__pjGR\\+ {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .PaymentSettingsModal_CustomTable_tableheadlight__HuHZw__4dkSt th:first-child,
thead .PaymentSettingsModal_CustomTable_tableheaddark__nwqb4__RMofR th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
}

@media only screen and (max-width: 1200px) {
  .PaymentSettingsModal_tableheadlight__VlNTb th {
    min-width: 170px;
  }
}
@media only screen and (max-width: 1024px) {
  .PaymentSettingsModal_dashboard__ExtGN {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden;
  }
  .PaymentSettingsModal_cont2__D2bFX {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
  /*.tableheadlight th {
    min-width: 200px !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .PaymentSettingsModal_sectionright__0fL2- {
    float: unset !important;
  }
  .PaymentSettingsModal_formthemelight__y9Tlf {
    padding: 10px 0 !important;
    box-shadow: none !important;
  }
  .PaymentSettingsModal_dashboard__ExtGN {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .PaymentSettingsModal_cont2__D2bFX {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .PaymentSettingsModal_bodythemelight__384-z,
.PaymentSettingsModal_bodythemedark__BqfuP {
    padding-top: 110px;
  }
  .PaymentSettingsModal_delPopContainer__7QEYf .PaymentSettingsModal_modal-content__bNvCT {
    min-width: 100%;
  }
  .PaymentSettingsModal_delPopContainer__7QEYf .PaymentSettingsModal_modal-body__3o6H5 {
    padding: 15px;
  }
  .PaymentSettingsModal_larg_model__Pv6G2 .PaymentSettingsModal_modal-content__bNvCT {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .PaymentSettingsModal_exer_modal_contain__pe0Uc .PaymentSettingsModal_modal-dialog__Zvdt\\+ {
    max-width: 1055px;
  }
  .PaymentSettingsModal_delPopContainer__7QEYf .PaymentSettingsModal_modal-dialog__Zvdt\\+ {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 200px;
  }*/
}
/* vk new changes */
.PaymentSettingsModal_active_show_outer__6GdL\\+ h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: "Plus Jakarta Sans", "Lufga", sans-serif !important;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO {
  width: 100%;
  display: block;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_img__dZoo5 {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_img__dZoo5 {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_img__dZoo5 img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_cnt__agVv9 {
  width: 100%;
  display: block;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_cnt__agVv9 svg {
  flex-shrink: 0;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_cnt__agVv9 .PaymentSettingsModal_act_box_bdg__wdMtF {
  width: 100%;
  margin-bottom: 12px;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_cnt__agVv9 .PaymentSettingsModal_act_box_bdg__wdMtF span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_cnt__agVv9 .PaymentSettingsModal_act_box_bdg__wdMtF .PaymentSettingsModal_sold__-Ejia {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_cnt__agVv9 h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_cnt__agVv9 p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.PaymentSettingsModal_active_show_outer__6GdL\\+ .PaymentSettingsModal_active_show_inner__f5BtO .PaymentSettingsModal_act_box_cnt__agVv9 p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}

/* vk new changes */
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_l__8wM21 img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: contain;
}
@media screen and (max-width: 767px) {
  .PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_l__8wM21 img {
    object-fit: contain;
    width: auto;
  }
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 {
  flex: 1 1;
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row__lF0Y2 {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row__lF0Y2 {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row__lF0Y2 .PaymentSettingsModal_attent_details_row_box__hs4Ij {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row__lF0Y2 .PaymentSettingsModal_attent_details_row_box__hs4Ij {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row__lF0Y2 .PaymentSettingsModal_attent_details_row_box__hs4Ij {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row__lF0Y2 .PaymentSettingsModal_attent_details_row_box__hs4Ij p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row__lF0Y2 .PaymentSettingsModal_attent_details_row_box__hs4Ij h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row_last__9QRBD {
  margin-bottom: 0px !important;
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row_last__9QRBD.PaymentSettingsModal_interesting_fact__4I1Eg {
  padding-top: 30px;
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row_last__9QRBD.PaymentSettingsModal_interesting_fact__4I1Eg .PaymentSettingsModal_attent_details_row_box__hs4Ij {
  width: 100%;
}
.PaymentSettingsModal_attent_details__cqrjv .PaymentSettingsModal_attent_details_inner__hVTxB .PaymentSettingsModal_attent_details_inner_r__wU8B8 .PaymentSettingsModal_attent_details_row_last__9QRBD.PaymentSettingsModal_interesting_fact__4I1Eg .PaymentSettingsModal_attent_details_row_box__hs4Ij h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.PaymentSettingsModal_showbox_sec__K34pu {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  align-items: stretch;
  width: 100%;
}
@media screen and (max-width: 500px) {
  .PaymentSettingsModal_showbox_sec__K34pu {
    grid-template-columns: 1fr;
  }
}

.PaymentSettingsModal_show_box_main__m\\+CVb {
  margin: 10px 0px;
  width: 100%;
}
.PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_show_box__63fG2 {
  min-height: 600px;
  width: 100%;
  margin-bottom: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_show_box__63fG2 {
    min-height: 500px;
  }
}
.PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_show_box__63fG2 .PaymentSettingsModal_active_show_inner__f5BtO {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_show_box__63fG2 .PaymentSettingsModal_act_box_img__dZoo5 {
  flex-shrink: 0;
}
.PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_show_box__63fG2 .PaymentSettingsModal_act_box_cnt__agVv9 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_show_box__63fG2 img {
  max-height: 400px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 767px) {
  .PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_show_box__63fG2 img {
    max-height: 300px !important;
  }
}
.PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_show_box__63fG2:last-child {
  margin-right: 0;
}
.PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_no_show_box__9v0Rw {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_no_show_box__9v0Rw {
    width: 250px !important;
  }
}
.PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_no_show_box__9v0Rw img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_no_show_box__9v0Rw img {
    max-height: 350px !important;
  }
}
.PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_no_show_box__9v0Rw h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .PaymentSettingsModal_show_box_main__m\\+CVb .PaymentSettingsModal_no_show_box__9v0Rw h6 {
    font-size: 20px;
  }
}

.PaymentSettingsModal_attent_flex__GVQgP {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.PaymentSettingsModal_attent_flex__GVQgP h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.PaymentSettingsModal_pay_modal__dxppb {
  width: auto;
}
.PaymentSettingsModal_pay_modal__dxppb .modal-dialog {
  margin-left: auto;
  margin-right: auto;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_modal_hd__-a\\+GB {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_modal_hd__-a\\+GB Button {
  background-color: transparent;
  border: none;
  padding: 0px;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF {
  padding: 26px 0px 0px 0px;
  overflow: auto;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_body_form__yDCIy {
  margin-right: 10px;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ {
  margin-bottom: 30px;
  position: relative;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_pay_label__gl08h {
  color: #727272;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 16px;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_pay_input__Dorlf {
  background-color: #f5f6fa;
  border-radius: 5px;
  min-height: 50px;
  border: none;
  padding: 10px;
  width: 100%;
  color: #727272;
  font-size: 16px;
  font-weight: 500;
  padding-left: 20px;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_pay_input__Dorlf:focus {
  outline: none;
  border: none;
  box-shadow: none;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_pay_input__Dorlf.PaymentSettingsModal_pay_input_copy__IMn3V {
  padding-right: 50px;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ ::placeholder {
  color: #727272;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_apply_contain__FlUS2 {
  display: flex;
  gap: 18px;
  margin-bottom: 18px;
}
@media only screen and (max-width: 767px) {
  .PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_apply_contain__FlUS2 {
    flex-direction: column;
  }
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_apply_contain__FlUS2 .PaymentSettingsModal_apply_hd__h3f8s {
  font-size: 14px;
  color: #727272;
  font-weight: 600;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_flat_amount__9A5us {
  position: relative;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_flat_amount__9A5us span {
  width: 40px;
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 16px;
  font-weight: 500;
  color: #727272;
  display: flex;
  align-items: center;
  justify-content: center;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_flat_amount__9A5us input {
  padding-left: 40px;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_percentage_amount__QTBwT span {
  left: auto;
  right: 0;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_percentage_amount__QTBwT input {
  padding-left: 20px;
  padding-right: 40px;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_both_fee_fields__g5nns {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_form_grp__0-AvZ .PaymentSettingsModal_pay_sub_label__djIsq {
  color: #727272;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_update_btn__6qgoE {
  width: 100%;
  height: 50px;
  background-color: #38A169;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  border: none;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_pay_update_btn__6qgoE:focus {
  outline: none;
  border: none;
  box-shadow: none;
}
.PaymentSettingsModal_pay_modal__dxppb .PaymentSettingsModal_pay_body__sadXF .PaymentSettingsModal_copy_btn__TYkig {
  background-color: transparent;
  padding: 0px;
  border: none;
  box-shadow: none;
  position: absolute;
  right: 20px;
  bottom: 15px;
}

.PaymentSettingsModal_custm_radio__rpcTB {
  display: flex;
  gap: 20px;
}
@media only screen and (max-width: 767px) {
  .PaymentSettingsModal_custm_radio__rpcTB {
    flex-direction: column;
  }
}
.PaymentSettingsModal_custm_radio__rpcTB [type=radio]:checked {
  position: absolute;
  left: -9999px;
}
.PaymentSettingsModal_custm_radio__rpcTB [type=radio]:checked + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #727272;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0px;
}
.PaymentSettingsModal_custm_radio__rpcTB [type=radio]:checked + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #131F43;
  border-radius: 100%;
  background: #fff;
}
.PaymentSettingsModal_custm_radio__rpcTB [type=radio]:checked + label:after {
  content: "";
  width: 8px;
  height: 8px;
  background: #131F43;
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 100%;
  transition: all 0.2s ease;
  opacity: 1;
  transform: scale(1);
}
.PaymentSettingsModal_custm_radio__rpcTB [type=radio]:not(:checked) {
  position: absolute;
  left: -9999px;
}
.PaymentSettingsModal_custm_radio__rpcTB [type=radio]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #727272;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0px;
}
.PaymentSettingsModal_custm_radio__rpcTB [type=radio]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  border: 1px solid #ABB0C5;
  border-radius: 100%;
  background: #fff;
}
.PaymentSettingsModal_custm_radio__rpcTB [type=radio]:not(:checked) + label:after {
  content: "";
  width: 8px;
  height: 8px;
  background: #131F43;
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 100%;
  transition: all 0.2s ease;
  opacity: 0;
  transform: scale(0);
}
.PaymentSettingsModal_custm_radio__rpcTB p {
  margin-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/PaymentSettingsModal/PaymentSettingsModal.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAmDC;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,gBAAA;ACxEH;;AD2EC;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEH;;AD2EC;;;EAGE,yBAnEoB;ACLvB;;AD2EC;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxEH;;AD2EC;;CAAA;AAIA;EACE,wBAzCU;EA0CV,UAzCS;EA0CT,kBAAA;EACA,aAjDiB;EAkDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACtEH;;AD4EC;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzEH;;AD8EC;EACE,2BAAA;AC3EH;;AD8EC;EACE,yBAAA;EACA,YAAA;AC3EH;;AD+EC;EACE,YAAA;AC5EH;;AD+EC;EACE,sBA9GY;ACkCf;;AD+EC;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC5EH;;AD+EC;EACE,yBArIgB;EAsIhB,iBAAA;AC5EH;;AD+EC;;CAAA;AAGA;EACE,sBAlIY;ACsDf;;AD+EC;EACE,yBAjJgB;ACqEnB;;AD+EC;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC5EH;;AD+EC;;CAAA;AAGA;EACE,sBAvJY;AC2Ef;;AD+EC;EACE,yBAtKgB;AC0FnB;;AD+EC;;CAAA;AAGA;EACE,yBAAA;AC5EH;;AD+EC;EACE,yBAAA;AC5EH;;AD+EC;;EAEE,sBAAA;AC5EH;;AD+EC;EACE,yBAxLsB;EAyLtB,cAnMkB;ACuHrB;;AD+EC;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC5EH;;AD+EC;EACE,yBAAA;AC5EH;;AD+EC;EACE,sBAAA;EACA,oCAAA;AC5EH;;AD+EC;EACE,0BAAA;AC5EH;;AD+EC;EACE,uBAAA;AC5EH;;AD+EC;EACE,0BAAA;AC5EH;;AD+EC;EACE,uBAAA;AC5EH;;AD+EC;;EAEE,qBAAA;AC5EH;;AD+EC;EACE,yBAjOsB;EAkOtB,WAzNY;AC6If;;AD+EC;;CAAA;AAGA;EACE,cA7Ne;ACiJlB;;AD+EC;EACE,cAjOe;ACqJlB;;AD+EC;;CAAA;AAGA;EACE,sBA3OY;EA4OZ,YAAA;AC5EH;;AD+EC;EACE,yBA3PgB;EA4PhB,WAjPY;EAkPZ,YAAA;AC5EH;;AD+EC;EACE,cAnPe;ACuKlB;;AD+EC;;CAAA;AAGA;EACE,yBA3Sc;EA4Sd,8BAAA;AC5EH;;AD+EC;EACE,WAlQY;ACsLf;;AD+EC;;EAEE,0BAAA;AC5EH;;AD+EC;;EAEE,0BAAA;AC5EH;;AD+EC;EACE,kBAAA;AC5EH;;AD+EC;EACE,kBAAA;AC5EH;;AD+EC;EACE,oCAAA;EACA,gCAAA;AC5EH;;AD+EC;EACE,yBArRkB;EAsRlB,WA9RY;ACkNf;;AD+EC;EACE,yBAAA;AC5EH;;AD+EC;EACE,iBAAA;AC5EH;;AD+EC;;EAEE,+BAAA;EACA,iBAAA;AC5EH;;AD+EC;EACE,sBAhTY;ACoOf;AD8EG;EACE,sBAnTU;EAoTV,YAAA;AC5EL;;ADgFC;EACE,0CAAA;EACA,cAvTe;AC0OlB;AD+EG;EACE,yCAAA;EACA,eAAA;AC7EL;;ADiFC;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EH;;ADiFC;EACE,yBAAA;EACA,0BAAA;AC9EH;;ADiFC;;CAAA;AAGA;EACE,sBAnVY;EAoVZ,yBAAA;EACA,qDAAA;AC9EH;;ADiFC;EACE,yBAjVkB;EAkVlB,yBAAA;EACA,eAAA;AC9EH;ADgFG;EACE,cA3Va;AC6QlB;;ADmFC;;CAAA;AAGA;EACE,yBA1WgB;AC0RnB;;ADmFC;EACE,yBAAA;EACA,yBAAA;AChFH;;ADmFC;EACE,yBA1XoB;EA2XpB,yBAAA;AChFH;;ADmFC;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFH;;ADmFC;;CAAA;AAGA;EACE,sBA9XY;AC8Sf;;ADmFC;EACE,yBA1XkB;AC0SrB;;ADoFC;;CAAA;AAGA;EACE,iGAAA;EACA,sBA3YY;AC0Tf;;ADoFC;EACE,mBAAA;ACjFH;;ADoFC;EACE,gGAAA;EACA,sBApZY;ACmUf;;ADoFC;EACE,mBAAA;ACjFH;;ADoFC;EACE,gGAAA;EACA,sBA7ZY;AC4Uf;;ADoFC;EACE,mBAAA;ACjFH;;ADoFC;EACE,gGAAA;EACA,sBAtaY;ACqVf;;ADoFC;EACE,mBAAA;ACjFH;;ADoFC;;;;;;;;EAQE,WArbY;ACoWf;;ADoFC;;CAAA;AAGA;EACE,qCAAA;ACjFH;;ADoFC;EACE,cA7be;AC4WlB;;ADqFC;;CAAA;AAGA;EACE,sBAAA;AClFH;;ADqFC;EACE,yBAAA;AClFH;;ADqFC;EACE,yBAjekB;EAkelB,WAjdY;AC+Xf;;ADqFC;EACE,yBAtekB;EAuelB,WAtdY;ACoYf;;ADqFC;EACE,6BAAA;AClFH;;ADqFC;EACE,2BAAA;AClFH;;ADqFC;EACE,yBAnfkB;ACiarB;;ADqFC;EACE,yBAtfwB;ACoa3B;;ADqFC;EACE,WA1eY;EA2eZ,6BAAA;EACA,yBAAA;AClFH;;ADsFC;EACE,yBA5fgB;ACyanB;;ADsFC;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFH;;ADsFC;;;EAGE,oCAAA;EACA,sBAAA;ACnFH;;ADsFC;EACE,gBAAA;EACA,YAAA;EACA,WAxgBY;EAygBZ,yBAriBY;EAsiBZ,YAAA;EACA,eAAA;EACA,gBAhkBc;AC6ejB;;ADsFE;EACC,gBAAA;EACA,YAAA;EACA,WAlhBY;EAmhBZ,yBA/iBY;EAgjBZ,YAAA;EACA,eAAA;EACA,gBA1kBc;ACufjB;;ADsFC;EACE,yBAtjBY;ACmef;;ADsFC;EACE,yBA/iBkB;AC4drB;;ADsFC;EACE,yBAljBwB;AC+d3B;;ADsFC;EACE,cAxjBiB;ACqepB;;ADuFC;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFH;;ADuFC;EACE,WAjjBY;EAkjBZ,yBA9kBY;EA+kBZ,YAAA;ACpFH;;ADuFC;EACE,QAAA;ACpFH;;ADwFC;EACE,gBAAA;EACA,YAAA;EACA,yBAnlBW;EAolBX,WA/jBY;EAgkBZ,eAAA;EACA,gBArnBc;EAsnBd,YAAA;ACrFH;;ADwFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACrFH;;ADwFC;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACrFH;;ADwFC;;;EAGE,yBA1mBW;EA2mBX,WAtlBY;EAulBZ,YAAA;ACrFH;;ADwFC;EACC,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,oCAAA;ACrFF;;ADwFC;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACrFH;;ADwFC;;;EAGE,oCAAA;ACrFH;;ADwFC;EACC,kBAAA;EACA,kBAAA;EACA,SAAA;ACrFF;;AD0FC;EACE,aAAA;EACA,kBAAA;ACvFH;;AD0FC;EACE,mBAAA;ACvFH;;AD0FC;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACvFH;;AD0FC;EACE,UAAA;ACvFH;;AD0FC;EACE,yCA7pBc;EA8pBd,cAlqBkB;AC2kBrB;;AD0FC;EACE,aAtqBkB;AC+kBrB;;AD0FC;EACE,yBAlqBgB;AC2kBnB;;AD0FC;EACE,yBAAA;ACvFH;;AD0FC;EACE,6BAAA;EACA,yBAAA;EACA,WAjqBY;AC0kBf;;AD0FC;;EAEE,yBAvrBkB;EAwrBlB,WAvqBY;ACglBf;;AD0FC;EACE,6BAAA;EACA,yBAAA;EACA,WA7qBY;ACslBf;;AD0FC;EACE,yBA1rBsB;EA2rBtB,WAlrBY;AC2lBf;;AD0FC;;;EAGE,WAxrBY;ACimBf;;AD0FC;;EAEE,yBAxsBgB;EAysBhB,WA9rBY;ACumBf;;AD0FC;EACE,yBAjvBO;AC0pBV;;AD0FC;EACE,eAjtBgB;AC0nBnB;;AD0FC;EACE,YA1sBY;ACmnBf;;AD0FC;;EAEE,sBAAA;ACvFH;;AD0FC,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC3FH;;AD8FC;EACE,0BAAA;AC3FH;;AD8FC;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC3FH;;AD8FC;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC3FH;;AD8FC;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC3FH;;AD8FC;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC3FH;;AD8FC;;EAEE,0BAAA;EACA,aAAA;AC3FH;;AD8FC;EACE,kBAAA;AC3FH;;AD8FC;EACE;IACE,gBAAA;EC3FH;AACF;AD8FC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kBAAA;EC5FH;ED+FC;IACE,2BAAA;IACA,gBAAA;EC7FH;AACF;ADgGC;EACE;;IAAA;EAGA;;IAAA;AC5FH;ADiGC;EACE;IACE,uBAAA;EC/FH;EDiGD;IACE,0BAAA;IACA,2BAAA;EC/FD;EDiGC;IACE,6BAAA;EC/FH;AACF;ADkGC;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGH;EDmGC;;IAEE,kBAAA;ECjGH;EDoGC;IACE,eAAA;EClGH;EDqGC;IACE,aAAA;ECnGH;EDsGC;IACE,8BAAA;IACA,aAAA;ECpGH;AACF;ADuGC;EACE;IACE,iBAAA;ECrGH;EDwGC;IACE,gBAAA;ECtGH;EDyGC;;IAAA;ACrGH;AD0GC,mBAAA;AAGA;EACE,iCAAA;EACA,gEAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GH;AD6GG;EACE,WAAA;EACA,cAAA;AC3GL;AD6GK;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AC3GP;AD4GO;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECzGP;AACF;AD0GO;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACxGT;AD4GK;EACE,WAAA;EACA,cAAA;AC1GP;AD2GC;EACC,cAAA;ACzGF;AD2GO;EACE,WAAA;EACA,mBAAA;ACzGT;AD2GS;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACzGX;AD4GS;EACE,kFAAA;AC1GX;AD+GO;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC7GT;ADgHO;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC9GT;ADgHS;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC9GX;;ADqHC,mBAAA;AAEE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACnHL;ADqHK;EATF;IAUI,yBAAA;EClHL;AACF;ADoHK;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;ECjHL;AACF;ADoHO;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AClHT;ADmHS;EALF;IAMG,mBAAA;IACA,WAAA;EChHR;AACF;ADoHK;EACE,SAAA;AClHP;ADoHO;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHT;ADoHS;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHT;AACF;ADmHS;EACE,SAAA;EACA,UAAA;ACjHX;ADmHW;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHX;AACF;ADkHW;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GX;AACF;ADiHW;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/Gb;ADkHW;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHb;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADwHC;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;ACrHH;ADsHG;EANF;IAOI,0BAAA;ECnHH;AACF;;ADqHC;EACE,gBAAA;EACA,WAAA;AClHH;ADoHG;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AClHL;ADoHK;EATF;IAUI,iBAAA;ECjHL;AACF;ADmHK;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ACjHP;ADoHK;EACE,cAAA;AClHP;ADqHK;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;ACnHP;ADsHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;ACpHP;ADsHO;EANF;IAOI,4BAAA;ECnHP;AACF;ADsHK;EACE,eAAA;ACpHP;ADwHG;EACE,YAAA;EACA,mBAAA;EACA,cAAA;ACtHL;ADwHK;EALF;IAMI,uBAAA;ECrHL;AACF;ADuHK;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACrHP;ADuHO;EALF;IAMI,4BAAA;ECpHP;AACF;ADsHK;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ACpHP;ADqHO;EARF;IASI,eAAA;EClHP;AACF;;ADyHC;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;ACtHH;ADwHG;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ACtHL;;AAhlCA;EACI,WAAA;AAmlCJ;AAllCI;EACI,iBAAA;EACA,kBAAA;AAolCR;AAllCI;EACI,qBAAA;EACA,iCAAA;AAolCR;AAnlCQ;EACI,6BAAA;EACA,YAAA;EACA,YAAA;AAqlCZ;AAllCI;EACI,yBAAA;EACA,cAAA;AAolCR;AAnlCQ;EACI,kBAAA;AAqlCZ;AAnlCQ;EACI,mBAAA;EACA,kBAAA;AAqlCZ;AAplCY;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAslChB;AAplCY;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAslChB;AArlCgB;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AAulCpB;AArlCgB;EACI,mBAAA;AAulCpB;AAplCY;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAslChB;AAplCY;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAslChB;AArlCgB;EAJJ;IAKQ,sBAAA;EAwlClB;AACF;AAvlCgB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAylCpB;AAtlCY;EACI,kBAAA;AAwlChB;AAvlCgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAylCpB;AAvlCgB;EACI,kBAAA;AAylCpB;AArlCgB;EACI,UAAA;EACA,QAAA;AAulCpB;AArlCgB;EACI,kBAAA;EACA,mBAAA;AAulCpB;AAplCY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAslChB;AAplCY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAslChB;AAnlCQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAqlCZ;AAplCY;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AAslChB;AAnlCQ;EACI,6BAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAqlCZ;;AA/kCA;EACI,aAAA;EACA,SAAA;AAklCJ;AAjlCI;EAHJ;IAIQ,sBAAA;EAolCN;AACF;AAllCE;EACC,kBAAA;EACA,aAAA;AAolCH;AAllCI;EACC,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACe,eAAA;EACA,gBAAA;EACA,kBAAA;AAolCpB;AAnlCK;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAqlCN;AAnlCK;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EAEA,yBAAA;EACA,UAAA;EAEA,mBAAA;AAqlCN;AAhlCE;EACC,kBAAA;EACA,aAAA;AAklCH;AAhlCI;EACC,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACe,eAAA;EACA,gBAAA;EACA,kBAAA;AAklCpB;AAjlCK;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAmlCN;AAjlCK;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EAEA,yBAAA;EACA,UAAA;EAEA,mBAAA;AAmlCN;AA7kCI;EACI,kBAAA;AA+kCR","sourcesContent":["/* \nscss\n */\n $font-regular: 400;\n $font-medium: 500;\n $font-semiBold: 600;\n $font-bold: 700;\n $font-extraBold: 800;\n $font-black: 900;\n \n $mainBg: #F5F6FA;\n $primary-color: #131F43;\n $icon-bgcolor: #F6F6F6;\n $text-graycolor: #727272;\n $cardIcon1-bg: #F3F4F8;\n $cardIcon1-darkbg: #30231a;\n $cardIcon1-darkbg-icon: #9d785f;\n $cardIcon2-bg: #FAF4FB;\n $cardIcon2-darkbg: #13252a;\n $cardIcon2-darkbg-icon: #3b606a;\n $cardIcon3-bg: #FAF7F3;\n $cardIcon3-darkbg: #2c1a27;\n $cardIcon3-darkbg-icon: #6c4863;\n $cardIcon4-bg: #F5F9FC;\n $cardIcon4-darkbg: #241d3e;\n $cardIcon4-darkbg-icon: #5f538b;\n $cardIcon2-color: #AC44BB;\n $cardIcon3-color: #D69A5F;\n $cardIcon4-color: #176CA5;\n $green-color: #38A169;\n $darkGreen-color: #207a4a;\n $placeholder-color: #666666;\n $profile-dark-text: #181818;\n $heading : #0B0D0F;\n $light-gray : #999999;\n $menu_icon : #CBCBCB;\n $red-color : #F94747;\n $red-hover : #960101;\n $dark-active-blue : #3b82f6;\n $dark-light-blue : #92afd3;\n $addBtn-dark-blue : #3b82f6;\n $addBtn-dark-blue-hover : #2563eb;\n $backBtn-dark : #3b82f633;\n \n \n \n $darkTheme_blue : #132337;\n $darkTheme_darkBlue : #0f1824;\n $darkTheme_selectBlue : #1c2e45;\n $darkTheme_updateBtn : #0a2574;\n \n /* \n Body Theme Color\n  */\n $lightthemecolor: #f3f6f9;\n $darkthemecolor: #151521;\n \n $white-color: #fff;\n $black-color: #1d1d1d;\n $fullBlack-color: #1d1d1d;\n $lightthemetext: #60677e;\n \n /* \n Dark Theme Colors\n */\n $primarydark-color: #132337;\n \n /* \n Button Theme\n */\n $primary-btncolor: #131F43;\n $secondary-btncolor: rgba(37, 105, 109, 0.864);\n \n $tableheadlightbg: #e9eaf0;\n \n \n /* \n Max Dashboard scss\n */\n $dashboardwidth: calc(100% - 320px);\n $dashboardposition: absolute;\n $dashboardleft: 290px;\n $dashboardpadding: 30px;\n \n /* \n Min Dashboard scss\n */\n $dashwidth: calc(100% - 50px);\n $dashleft: 50px;\n \n /* \n Max Dashboard scss\n */\n \n .dashboard {\n   width: $dashboardwidth;\n   position: relative;\n   left: $dashboardleft;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   min-height: auto !important;\n   background-color: $mainBg;\n   overflow-y: auto;\n }\n \n .dashboardContain {\n   width: calc(100% - 320px);\n   background-Color: $mainBg;\n   border-radius: 8px;\n }\n \n .bodythemedark .dashboardContain,\n .bodythemedark .dashboard,\n .bodythemedark .cont2 {\n   background-Color: $darkTheme_darkBlue;\n }\n \n .top_header .top_header_inner {\n   background-color: transparent;\n   height: auto;\n   overflow-y: unset;\n }\n \n /* \n Min Dashboard scss\n */\n \n .cont2 {\n   width: $dashwidth;\n   left: $dashleft;\n   position: relative;\n   padding: $dashboardpadding;\n   border-radius: 8px;\n   background: $mainBg;\n   /*height: calc(100vh - 160px);*/\n   height: 100%;\n   min-height: auto !important;\n   overflow-y: auto;\n   /* \n background-Color: $dashboardbackgroundColor;\n   padding-bottom: 8%;\n */\n }\n \n .subLink svg {\n   position: relative;\n   top: -2px;\n   left: -7px;\n }\n \n \n \n .cst_vendr input {\n   min-height: 35px !important;\n }\n \n .cst_vendr .form-control {\n   background-color: #f5f6fa;\n   border: none;\n }\n \n \n .footer {\n   height: 70px;\n }\n \n body {\n   background-color: $white-color;\n }\n \n /* \n THEME CHANGE\n */\n .bodythemelight {\n   background-color: $white-color;\n   padding-top: 90px;\n }\n \n .bodythemedark {\n   background-color: $darkTheme_blue;\n   padding-top: 90px;\n }\n \n /* \n Header Navbar Theme\n */\n .headerthemelight {\n   background-color: $white-color;\n }\n \n .headerthemedark {\n   background-color: $darkTheme_blue;\n }\n \n .top_header {\n   min-height: 90px;\n   display: flex;\n   align-items: center;\n   position: fixed;\n   width: 100%;\n   z-index: 2;\n   top: 0;\n }\n \n /* \n LEFT MENU THEME CHANGE\n */\n .menuthemelight {\n   background-color: $white-color;\n }\n \n .menuthemedark {\n   background-color: $darkTheme_blue;\n }\n \n /* \n LEFT MENU LINKS THEME CHANGE\n */\n .menulinklight span {\n   color: $placeholder-color !important;\n }\n \n .menulinklight a {\n   color: $menu_icon !important;\n }\n \n .menulinklight:hover span,\n .menulinklight:hover a {\n   color: $white-color !important;\n }\n \n .menulinkdarkSelected {\n   background-color: $darkTheme_selectBlue;\n   color: $dark-active-blue;\n }\n \n .menuthemelight .menulinklightSelected {\n   /*background-color: $lightthemecolor;*/\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinkdark {\n   color: $dark-light-blue !important;\n }\n \n .menulinklight:hover {\n   color: $white-color !important;\n   background-color: $primary-color !important;\n }\n \n .menulinklight .sub_arrow svg path {\n   stroke: $menu_icon !important;\n }\n \n .menulinklight:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinkdark .sub_arrow svg path {\n   stroke: $dark-light-blue !important;\n }\n \n .menulinkdark:hover .sub_arrow svg path {\n   stroke: $white-color !important;\n }\n \n .menulinklight:hover svg path,\n .menulinklightSelected svg path {\n   fill: #fff !important;\n }\n \n .menulinkdark:hover {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n /* \n BODY HEADERS\n */\n .headinglight {\n   color: $lightthemetext;\n }\n \n .headingdark {\n   color: $lightthemetext;\n }\n \n /* \n SEARCH BOX THEME COLOR\n */\n .searchboxlight {\n   background-color: $white-color;\n   border: none;\n }\n \n .searchboxdark {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n   border: none;\n }\n \n .searchboxdark::placeholder {\n   color: $lightthemetext;\n }\n \n /* \n CUSTOM TABLE THEME COLOR\n */\n .tableheadlight {\n   background-color: $primary-color;\n   border-radius: 5px 5px 0px 0px;\n }\n \n .tableheadlight th {\n   color: $white-color;\n }\n \n thead .tableheadlight th:first-child,\n thead .tableheaddark th:first-child {\n   border-radius: 5px 0 0 0px;\n }\n \n thead .tableheadlight th:last-child,\n thead .tableheaddark th:last-child {\n   border-radius: 0 5px 0px 0;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n td:last-child {\n   border-radius: 0px;\n }\n \n table.table.table-borderless {\n   border-collapse: separate !important;\n   border-spacing: 0 0px !important;\n }\n \n .tableheaddark {\n   background-color: $primarydark-color;\n   color: $white-color;\n }\n \n .table-borderless tr:nth-child(even) {\n   background-color: #F9FAFB;\n }\n \n .table-borderless .left-section {\n   padding-top: 10px;\n }\n \n .tablebodylight td,\n .tablebodydark td {\n   padding: 0.5rem 1rem !important;\n   line-height: 45px;\n }\n \n .tablebodylight {\n   background-color: $white-color;\n \n   &:hover {\n     background-color: $white-color;\n     cursor: auto;\n   }\n }\n \n .tablebodydark {\n   /* background-color: $primarydark-color; */\n   color: $lightthemetext;\n \n   &:hover {\n     background-color: rgba(33, 150, 243, 0.1);\n     cursor: pointer;\n   }\n }\n \n /* \n PAGINATION THEME COLOR\n */\n .paginationlight {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n .paginationdark {\n   color: $lightthemetext !important;\n   font-size: 13px !important;\n }\n \n /* \n SETTING FORM THEME COLOR\n */\n .formthemelight {\n   background-color: $white-color;\n   color: $black-color !important;\n   box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n }\n \n .formthemedark {\n   background-color: $primarydark-color;\n   color: $lightthemetext !important;\n   font-size: 14px;\n \n   ::placeholder {\n     color: $lightthemetext;\n   }\n }\n \n \n /* \n VIEW FORM DETAILS BOX THEME COLOR\n */\n .viewformlight {\n   background-color: $lightthemecolor;\n }\n \n .permissionboxlight {\n   background-color: #f8f9fa;\n   border: 1px solid #dee2e6;\n }\n \n .permissionboxdark {\n   background-color: $darkTheme_darkBlue;\n   border: solid 1px #242434;\n }\n \n .errormsgclr {\n   color: red;\n   font-size: 14px;\n   margin-top: 5px;\n }\n \n /* \n Graph theme\n */\n .graphclrlight {\n   background-color: $white-color;\n }\n \n .graphclrdark {\n   background-color: $primarydark-color;\n }\n \n \n /* \n Counter theme\n */\n #card1bglight {\n   /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card1bgdark {\n   background: #392f28;\n }\n \n #card2bglight {\n   /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card2bgdark {\n   background: #1c3238;\n }\n \n #card3bglight {\n   /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card3bgdark {\n   background: #3a2434;\n }\n \n #card4bglight {\n   /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n   background-color: $white-color;\n }\n \n #card4bgdark {\n   background: #2f264f;\n }\n \n #card1bgdark a,\n #card1bgdark p,\n #card2bgdark a,\n #card2bgdark p,\n #card3bgdark a,\n #card3bgdark p,\n #card4bgdark a,\n #card4bgdark p {\n   color: $white-color;\n }\n \n /* \n Action button theme\n */\n .actionbtnlight {\n   color: #46475bde;\n }\n \n .actionbtndark {\n   color: $lightthemetext;\n }\n \n \n /* \n profile dropdowntheme\n */\n .profiledropdownlight {\n   background-color: #fff;\n }\n \n .profiledropdowndark {\n   background-color: #151521;\n }\n \n .settingsection #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n #addform.formthemedark .savebtn {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .profile_conatiner {\n   border-radius: 5px !important;\n }\n \n .bodythemedark .ag-theme-alpine .ag-row {\n   background: #000 !important;\n }\n \n .bodythemedark .formbtn {\n   background-color: $addBtn-dark-blue;\n }\n \n .bodythemedark .formbtn:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .bodythemedark .resetbtn {\n   color: $white-color;\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n }\n \n \n .headingdark span {\n   background-color: $darkTheme_blue;\n }\n \n .resetbtn {\n   font-size: 16px !important;\n   font-weight: $font-semiBold !important;\n   border-radius: 5px !important;\n   background-color: transparent !important;\n   border: solid 1px $primary-color !important;\n   color: $primary-color !important;\n   min-width: 113px !important;\n }\n \n .resetbtn:hover,\n .resetbtn:active,\n .resetbtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n }\n \n .addBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n\n  .addDltBtn {\n   min-width: 140px;\n   height: 44px;\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n }\n \n .addbtnlight {\n   background-color: $green-color;\n }\n \n .addbtndark {\n   background-color: $addBtn-dark-blue;\n }\n \n .addbtndark:hover {\n   background-color: $addBtn-dark-blue-hover;\n }\n \n .formthemedark label {\n   color: $dark-light-blue;\n }\n \n \n .addBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: 2px;\n }\n \n .addBtn:hover {\n   color: $white-color;\n   background-color: $green-color;\n   border: none;\n }\n \n .cust_addBtn.addBtn svg {\n   top: 2px;\n }\n \n \n .deleteBtn {\n   min-width: 130px;\n   height: 50px;\n   background-color: $red-color;\n   color: $white-color;\n   font-size: 16px;\n   font-weight: $font-semiBold;\n   border: none;\n }\n \n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .deleteBtn svg {\n   margin-right: 10px;\n   position: relative;\n   top: -2px;\n }\n \n .deleteBtn:hover,\n .deleteBtn:active,\n .deleteBtn:focus {\n   background-color: $red-color;\n   color: $white-color;\n   border: none;\n }\n \n .confirmBtn {\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  background-color: $primary-color !important;\n }\n\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $primary-color !important;\n   color: $white-color !important;\n   box-shadow: none !important;\n }\n \n .confirmBtn:hover,\n .confirmBtn:active,\n .confirmBtn:focus {\n   background-color: $darkTheme_darkBlue !important;\n }\n \n .confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n \n \n \n .delPopContainer .modal-body {\n   padding: 35px;\n   text-align: center;\n }\n \n .delPopContainer .delet_icon {\n   margin-bottom: 11px;\n }\n \n .delPopContainer p {\n   color: #131f43;\n   font-size: 14px;\n   font-weight: 700;\n   padding: 0 20px;\n }\n \n .arrowback svg {\n   fill: #000;\n }\n \n .bodythemedark .arrowback {\n   background-color: $backBtn-dark;\n   color: $dark-active-blue;\n }\n \n .bodythemedark .arrowback svg {\n   fill: $dark-active-blue;\n }\n \n .bodythemedark .drpdwn_btn {\n   background-color: $darkTheme_blue;\n }\n \n .bodythemedark .empname {\n   color: $dark-light-blue !important;\n }\n \n .bodythemedark .navitemli a {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingsgeneral,\n .bodythemedark .tabnavli a.settingslinks:hover {\n   background-color: $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .bodythemedark .tabnavli a.settingslinks {\n   background-color: transparent;\n   border: solid 1px $addBtn-dark-blue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain {\n   background-color: $darkTheme_selectBlue;\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a,\n .headerthemedark .dropdown_menu_contain .dropdown_item,\n .headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n   color: $white-color;\n }\n \n .headerthemedark .dropdown_menu_contain ul li a:hover,\n .headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n   background-color: $darkTheme_blue;\n   color: $white-color;\n }\n \n .dropdown_item:active {\n   background-color: $mainBg;\n }\n \n .profile_arrrow_dwn {\n   stroke: $darkTheme_blue;\n }\n \n .headerthemedark .profile_arrrow_dwn {\n   stroke: $white-color;\n }\n \n .dateinputbox1 input,\n .dateinputbox1 span {\n   color: $white-color !important;\n }\n \n /* LOGOUT MODAL */\n .modalStyleLight {}\n \n .modalStyleDark {}\n \n .delPopContainer .modal-content {\n   border-radius: 10px;\n   min-width: 399px;\n }\n \n .larg_model .modal-dialog {\n   max-width: 100% !important;\n }\n \n .larg_model .modal-content {\n   /* display: inline-block; */\n   height: 100%;\n   max-width: 900px;\n   margin: auto;\n   border-radius: 54px !important;\n   background: #FFF;\n   padding: 53px 53px 23px;\n }\n \n .larg_model .modal-header {\n   padding: 0px 0px 23px;\n   border-bottom: 1px dashed #D4D9EE;\n   display: block;\n }\n \n body .btn-primary:hover {\n   background-color: transparent;\n   border-color: #131F43;\n   color: #131F43;\n   fill: #131F43;\n   border: 1px solid;\n }\n \n .form-select {\n   display: block;\n   width: 100%;\n   padding: .375rem 2.25rem .375rem .75rem;\n   -moz-padding-start: calc(0.75rem - 3px);\n   font-size: 1rem;\n   font-weight: 400;\n   line-height: 1.5;\n   color: #212529;\n   background-color: #fff;\n   background-image: url(../../assets/select_arow.svg) !important;\n }\n \n thead .CustomTable_tableheadlight__HuHZw th:first-child,\n thead .CustomTable_tableheaddark__nwqb4 th:first-child {\n   border-radius: 5px 0 0 0px;\n   display: math;\n }\n \n th:first-child {\n   border-radius: 0px;\n }\n \n @media only screen and (max-width: 1200px) {\n   .tableheadlight th {\n     min-width: 170px;\n   }\n }\n \n @media only screen and (max-width: 1024px) {\n   .dashboard {\n     width: calc(100% - 50px) !important;\n     left: 50px !important;\n     padding: 10px 10px !important;\n     overflow-x: hidden;\n   }\n \n   .cont2 {\n     height: calc(100vh - 160px);\n     overflow-y: auto;\n   }\n }\n \n @media only screen and (max-width: 998px) {\n   /* #dashboardcont2{\n     height: auto !important;\n   }*/\n   /*.tableheadlight th {\n     min-width: 200px !important;\n   }*/\n }\n \n @media only screen and (max-width: 767px) {\n   .sectionright {\n     float: unset !important;\n   }\n .formthemelight {\n   padding: 10px 0!important;\n   box-shadow: none !important;\n }\n   .dashboard {\n     padding: 10px 10px !important;\n   }\n }\n \n @media only screen and (max-width: 600px) {\n   .cont2 {\n     width: $dashwidth !important;\n     left: $dashleft !important;\n     position: relative !important;\n     padding: 10px 10px 15px !important;\n   }\n \n   .bodythemelight,\n   .bodythemedark {\n     padding-top: 110px;\n   }\n \n   .delPopContainer .modal-content {\n     min-width: 100%;\n   }\n \n   .delPopContainer .modal-body {\n     padding: 15px;\n   }\n \n   .larg_model .modal-content {\n     border-radius: 20px !important;\n     padding: 22px;\n   }\n }\n \n @media (min-width: 576px) {\n   .exer_modal_contain .modal-dialog {\n     max-width: 1055px;\n   }\n \n   .delPopContainer .modal-dialog {\n     max-width: 350px;\n   }\n \n   /*.tableheadlight th {\n     min-width: 200px;\n   }*/\n }\n \n /* vk new changes */\n .active_show_outer {\n \n h2 {\n   color: var(--Font-black, #0B0D0F);\n   font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n   font-size: 22px;\n   font-style: normal;\n   font-weight: 700;\n   line-height: normal;\n }\n \n   .active_show_inner {\n     width: 100%;\n     display: block;\n \n     .act_box_img {\n       margin-bottom: 12px;\n       min-height: 400px;\n       object-fit: cover;\n       overflow: hidden;\n       height: 400px;\n       max-height: 400px;\n       @media (max-width: 767px) {\n         min-height: 300px;\n         height: 300px;\n         max-height: 300px;\n       }\n       img {\n         max-height: 400px;\n         /* align-self: stretch; */\n         width: 100%;\n         height: 100%;\n         border-radius: 12px;\n         object-fit: cover;\n       }\n     }\n \n     .act_box_cnt {\n       width: 100%;\n       display: block;\n svg{\n  flex-shrink: 0;\n }\n       .act_box_bdg {\n         width: 100%;\n         margin-bottom: 12px;\n \n         span {\n           background: url(../../assets/ongoing.png) right top no-repeat;\n           width: 111px;\n           display: block;\n           height: 34px;\n           color: var(--White, #FFF);\n           font-size: 18px;\n           font-style: normal;\n           font-weight: 500;\n           padding: 3px 8px;\n         }\n \n         .sold {\n           background: url(../../assets/sold.png) right top no-repeat !important;\n         }\n \n       }\n \n       h3 {\n         color: var(--Secondary, #132941);\n         font-size: 18px;\n         font-style: normal;\n         font-weight: 600;\n         line-height: 26.304px;\n         margin: 0;\n       }\n \n       p {\n         display: flex;\n         align-items: center;\n         gap: 10px;\n         margin-bottom: 5px;\n \n         span {\n           color: var(--Light-1, #736B66);\n           font-size: 14px;\n           font-style: normal;\n           font-weight: 500;\n           line-height: 26.304px;\n         }\n       }\n     }\n   }\n }\n \n /* vk new changes */\n .attent_details {\n   .attent_details_inner {\n     display: flex;\n     gap: 61px;\n     padding: 20px;\n     border-radius: 5px;\n     background: #FFF;\n     box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n     align-items: center;\n \n     @media (max-width: 576px) {\n       display: block !important;\n     }\n \n     @media (max-width: 992px) {\n       display: flex;\n       gap: 20px;\n       align-items: start;\n     }\n \n     .attent_details_inner_l {\n       img {\n         width: 187px;\n         height: 207px;\n         flex-shrink: 0;\n         object-fit: contain;\n         @media screen and (max-width:767px) {\n          object-fit: contain;\n          width: auto;\n         }\n       }\n     }\n \n     .attent_details_inner_r {\n       flex: 1;\n \n       .attent_details_row {\n         display: flex;\n         gap: 20px;\n         margin-bottom: 28px;\n \n         @media (max-width: 992px) {\n           margin-bottom: 0px;\n           display: inline-block;\n           width: 100%;\n         }\n \n         .attent_details_row_box {\n           flex: 1;\n           width: 22%;\n \n           @media (max-width: 576px) {\n             margin: 15px 0px 10px !important;\n             width: 100% !important;\n           }\n \n           @media (max-width: 992px) {\n             margin-bottom: 15px;\n             float: left;\n             margin-right: 0;\n             width: 50%;\n             padding-right: 10px;\n           }\n \n           p {\n             margin-bottom: 10px;\n             color: #727272;\n             font-size: 13px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n           }\n \n           h5 {\n             color: #131F43;\n             font-size: 16px;\n             font-style: normal;\n             font-weight: 600;\n             line-height: normal;\n             word-wrap: break-word;\n           }\n         }\n       }\n \n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n     }\n   }\n }\n .showbox_sec {\n   display: grid;\n   grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n   gap: 20px;\n   align-items: stretch;\n   width: 100%;\n   @media screen and (max-width: 500px) {\n     grid-template-columns: 1fr;\n   }\n }\n .show_box_main {\n   margin: 10px 0px;\n   width: 100%;\n\n   .show_box {\n     min-height: 600px;\n     width: 100%;\n     margin-bottom: 0;\n     cursor: pointer;\n     display: flex;\n     flex-direction: column;\n     box-sizing: border-box;\n\n     @media (max-width: 767px) {\n       min-height: 500px;\n     }\n\n     .active_show_inner {\n       display: flex;\n       flex-direction: column;\n       flex: 1;\n       min-height: 0;\n     }\n\n     .act_box_img {\n       flex-shrink: 0;\n     }\n\n     .act_box_cnt {\n       flex: 1;\n       display: flex;\n       flex-direction: column;\n       min-height: 0;\n     }\n\n     img {\n       max-height: 400px;\n       height: 100%;\n       width: 100%;\n       object-fit: cover;\n\n       @media (max-width: 767px) {\n         max-height: 300px !important;\n       }\n     }\n\n     &:last-child {\n       margin-right: 0;\n     }\n   }\n \n   .no_show_box {\n     width: 350px;\n     margin: 0 auto 20px;\n     display: block;\n   \n     @media (max-width: 767px) {\n       width: 250px !important;\n     }\n   \n     img {\n       max-height: 450px;\n       height: 100%;\n       width: 100%;\n   \n       @media (max-width: 767px) {\n         max-height: 350px !important;\n       }\n     }\n     h6 {\n       color: #000;\n       text-align: center;\n       font-size: 26px;\n       font-style: normal;\n       font-weight: 700;\n       line-height: normal;\n       margin-top: 20px;\n       @media only screen and (max-width: 600px) {\n         font-size: 20px;\n       }\n     }\n   }\n   \n \n }\n \n .attent_flex {\n   justify-content: space-between !important;\n   gap: 30px;\n   align-items: center;\n \n   h5 {\n     font-size: 22px;\n     font-style: normal;\n     font-weight: 700;\n   }\n }\n","@import \"../../styles/Variables/Variables.scss\";\n\n.pay_modal {\n    width: auto;\n    :global(.modal-dialog) {\n        margin-left: auto;\n        margin-right: auto;\n    }\n    .pay_modal_hd {\n        padding: 0px 0px 23px;\n        border-bottom: 1px dashed #D4D9EE;\n        Button {\n            background-color: transparent;\n            border: none;\n            padding: 0px;\n        }\n    }\n    .pay_body {\n        padding: 26px 0px 0px 0px;\n        overflow: auto;\n        .pay_body_form {\n            margin-right: 10px;\n        }\n        .pay_form_grp {\n            margin-bottom: 30px;\n            position: relative;\n            .pay_label {\n                color: #727272;\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: normal;\n                margin-bottom: 16px;\n            }\n            .pay_input {\n                background-color: #f5f6fa;\n                border-radius: 5px;\n                min-height: 50px;\n                border: none;\n                padding: 10px;\n                width: 100%;\n                color: #727272;\n                font-size: 16px;\n                font-weight: 500;\n                padding-left: 20px;\n                &:focus {\n                    outline: none;\n                    border: none;\n                    box-shadow: none;\n                }\n                &.pay_input_copy {\n                    padding-right: 50px;\n                }\n            }\n            ::placeholder {\n                color: #727272;\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: normal;\n            }\n            .apply_contain {\n                display: flex;\n                gap: 18px;\n                margin-bottom: 18px;\n                @media only screen and (max-width: 767px) {\n                    flex-direction: column;\n                }\n                .apply_hd {\n                    font-size: 14px;\n                    color: #727272;\n                    font-weight: 600;\n                }\n            }\n            .flat_amount {\n                position: relative;\n                span {\n                    width: 40px;\n                    height: 50px;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    font-size: 16px;\n                    font-weight: 500;\n                    color: #727272;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                }\n                input {\n                    padding-left: 40px;\n                }\n            }\n            .percentage_amount {\n                span {\n                    left: auto;\n                    right: 0;\n                }\n                input {\n                    padding-left: 20px;\n                    padding-right: 40px;\n                }\n            }\n            .both_fee_fields {\n                display: flex;\n                flex-direction: column;\n                gap: 12px;\n            }\n            .pay_sub_label {\n                color: #727272;\n                font-size: 14px;\n                font-weight: 600;\n                margin-bottom: 0;\n            }\n        }\n        .pay_update_btn {\n            width: 100%;\n            height: 50px;\n            background-color: #38A169;\n            color: #fff;\n            font-size: 16px;\n            font-weight: 600;\n            border-radius: 5px;\n            border: none;\n            &:focus {\n                outline: none;\n                border: none;\n                box-shadow: none;\n            }\n        }\n        .copy_btn {\n            background-color: transparent;\n            padding: 0px;\n            border: none;\n            box-shadow: none;\n            position: absolute;\n            right: 20px;\n            bottom: 15px;\n        }\n    }\n}\n\n\n.custm_radio {\n    display: flex;\n    gap: 20px;\n    @media only screen and (max-width: 767px) {\n        flex-direction: column;\n    }\n\t[type=\"radio\"] {\n\t\t&:checked {\n\t\t\tposition: absolute;\n\t\t\tleft: -9999px;\n\t\t\t+ {\n\t\t\t\tlabel {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding-left: 28px;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tcolor: #727272;\n                    font-size: 14px;\n                    font-weight: 600;\n                    margin-bottom: 0px;\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\twidth: 18px;\n\t\t\t\t\t\theight: 18px;\n\t\t\t\t\t\tborder: 1px solid #131F43;\n\t\t\t\t\t\tborder-radius: 100%;\n\t\t\t\t\t\tbackground: #fff;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\twidth: 8px;\n\t\t\t\t\t\theight: 8px;\n\t\t\t\t\t\tbackground: #131F43;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 5px;\n\t\t\t\t\t\tleft: 5px;\n\t\t\t\t\t\tborder-radius: 100%;\n\t\t\t\t\t\t-webkit-transition: all 0.2s ease;\n\t\t\t\t\t\ttransition: all 0.2s ease;\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t-webkit-transform: scale(1);\n\t\t\t\t\t\ttransform: scale(1);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&:not(:checked) {\n\t\t\tposition: absolute;\n\t\t\tleft: -9999px;\n\t\t\t+ {\n\t\t\t\tlabel {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding-left: 28px;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tcolor: #727272;\n                    font-size: 14px;\n                    font-weight: 600;\n                    margin-bottom: 0px;\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\twidth: 16px;\n\t\t\t\t\t\theight: 16px;\n\t\t\t\t\t\tborder: 1px solid #ABB0C5;\n\t\t\t\t\t\tborder-radius: 100%;\n\t\t\t\t\t\tbackground: #fff;\n\t\t\t\t\t}\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\twidth: 8px;\n\t\t\t\t\t\theight: 8px;\n\t\t\t\t\t\tbackground: #131F43;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 5px;\n\t\t\t\t\t\tleft: 5px;\n\t\t\t\t\t\tborder-radius: 100%;\n\t\t\t\t\t\t-webkit-transition: all 0.2s ease;\n\t\t\t\t\t\ttransition: all 0.2s ease;\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\t-webkit-transform: scale(0);\n\t\t\t\t\t\ttransform: scale(0);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n    p {\n        margin-bottom: 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `PaymentSettingsModal_dashboard__ExtGN`,
	"dashboardContain": `PaymentSettingsModal_dashboardContain__iDUjH`,
	"bodythemedark": `PaymentSettingsModal_bodythemedark__BqfuP`,
	"cont2": `PaymentSettingsModal_cont2__D2bFX`,
	"top_header": `PaymentSettingsModal_top_header__aGudw`,
	"top_header_inner": `PaymentSettingsModal_top_header_inner__1Yhqp`,
	"subLink": `PaymentSettingsModal_subLink__JJXbl`,
	"cst_vendr": `PaymentSettingsModal_cst_vendr__kqJjx`,
	"form-control": `PaymentSettingsModal_form-control__N53Pk`,
	"footer": `PaymentSettingsModal_footer__UUI8l`,
	"bodythemelight": `PaymentSettingsModal_bodythemelight__384-z`,
	"headerthemelight": `PaymentSettingsModal_headerthemelight__mN+tN`,
	"headerthemedark": `PaymentSettingsModal_headerthemedark__Uomh1`,
	"menuthemelight": `PaymentSettingsModal_menuthemelight__+XwHr`,
	"menuthemedark": `PaymentSettingsModal_menuthemedark__TeoKy`,
	"menulinklight": `PaymentSettingsModal_menulinklight__WdDYG`,
	"menulinkdarkSelected": `PaymentSettingsModal_menulinkdarkSelected__RqArc`,
	"menulinklightSelected": `PaymentSettingsModal_menulinklightSelected__k06O8`,
	"menulinkdark": `PaymentSettingsModal_menulinkdark__Uwqd+`,
	"sub_arrow": `PaymentSettingsModal_sub_arrow__uJL0A`,
	"headinglight": `PaymentSettingsModal_headinglight__bSHB4`,
	"headingdark": `PaymentSettingsModal_headingdark__3w32M`,
	"searchboxlight": `PaymentSettingsModal_searchboxlight__5-M3g`,
	"searchboxdark": `PaymentSettingsModal_searchboxdark__RzjOr`,
	"tableheadlight": `PaymentSettingsModal_tableheadlight__VlNTb`,
	"tableheaddark": `PaymentSettingsModal_tableheaddark__6hydC`,
	"table": `PaymentSettingsModal_table__Z04HS`,
	"table-borderless": `PaymentSettingsModal_table-borderless__BZyTT`,
	"left-section": `PaymentSettingsModal_left-section__Sn21M`,
	"tablebodylight": `PaymentSettingsModal_tablebodylight__5TDgV`,
	"tablebodydark": `PaymentSettingsModal_tablebodydark__jT8wN`,
	"paginationlight": `PaymentSettingsModal_paginationlight__9UACm`,
	"paginationdark": `PaymentSettingsModal_paginationdark__t-1Vw`,
	"formthemelight": `PaymentSettingsModal_formthemelight__y9Tlf`,
	"formthemedark": `PaymentSettingsModal_formthemedark__Wo69v`,
	"viewformlight": `PaymentSettingsModal_viewformlight__zESmO`,
	"permissionboxlight": `PaymentSettingsModal_permissionboxlight__JyrrY`,
	"permissionboxdark": `PaymentSettingsModal_permissionboxdark__xFd+e`,
	"errormsgclr": `PaymentSettingsModal_errormsgclr__nLUYj`,
	"graphclrlight": `PaymentSettingsModal_graphclrlight__4-Wme`,
	"graphclrdark": `PaymentSettingsModal_graphclrdark__sgQ-Q`,
	"card1bglight": `PaymentSettingsModal_card1bglight__6gBl+`,
	"card1bgdark": `PaymentSettingsModal_card1bgdark__BdQlZ`,
	"card2bglight": `PaymentSettingsModal_card2bglight__Qe-1-`,
	"card2bgdark": `PaymentSettingsModal_card2bgdark__BdXve`,
	"card3bglight": `PaymentSettingsModal_card3bglight__7llzU`,
	"card3bgdark": `PaymentSettingsModal_card3bgdark__JQDS7`,
	"card4bglight": `PaymentSettingsModal_card4bglight__aFAj7`,
	"card4bgdark": `PaymentSettingsModal_card4bgdark__Whge2`,
	"actionbtnlight": `PaymentSettingsModal_actionbtnlight__KbI9t`,
	"actionbtndark": `PaymentSettingsModal_actionbtndark__NtzPb`,
	"profiledropdownlight": `PaymentSettingsModal_profiledropdownlight__Hq7sB`,
	"profiledropdowndark": `PaymentSettingsModal_profiledropdowndark__BdIVp`,
	"settingsection": `PaymentSettingsModal_settingsection__kTl2n`,
	"addform": `PaymentSettingsModal_addform__573sC`,
	"savebtn": `PaymentSettingsModal_savebtn__Sh0QS`,
	"profile_conatiner": `PaymentSettingsModal_profile_conatiner__Q8Uf9`,
	"ag-theme-alpine": `PaymentSettingsModal_ag-theme-alpine__kvTyN`,
	"ag-row": `PaymentSettingsModal_ag-row__z3z4g`,
	"formbtn": `PaymentSettingsModal_formbtn__0B-Wt`,
	"resetbtn": `PaymentSettingsModal_resetbtn__zuy58`,
	"addBtn": `PaymentSettingsModal_addBtn__LPsK9`,
	"addDltBtn": `PaymentSettingsModal_addDltBtn__H2Ndi`,
	"addbtnlight": `PaymentSettingsModal_addbtnlight__HAy0U`,
	"addbtndark": `PaymentSettingsModal_addbtndark__6uMpR`,
	"cust_addBtn": `PaymentSettingsModal_cust_addBtn__5ECU7`,
	"deleteBtn": `PaymentSettingsModal_deleteBtn__pSY2c`,
	"confirmBtn": `PaymentSettingsModal_confirmBtn__F5lQJ`,
	"delPopContainer": `PaymentSettingsModal_delPopContainer__7QEYf`,
	"modal-body": `PaymentSettingsModal_modal-body__3o6H5`,
	"delet_icon": `PaymentSettingsModal_delet_icon__h55u6`,
	"arrowback": `PaymentSettingsModal_arrowback__YpR4a`,
	"drpdwn_btn": `PaymentSettingsModal_drpdwn_btn__K0Wce`,
	"empname": `PaymentSettingsModal_empname__UuWxP`,
	"navitemli": `PaymentSettingsModal_navitemli__E8MFD`,
	"tabnavli": `PaymentSettingsModal_tabnavli__d8-kP`,
	"settingsgeneral": `PaymentSettingsModal_settingsgeneral__AHXjP`,
	"settingslinks": `PaymentSettingsModal_settingslinks__VdaPM`,
	"dropdown_menu_contain": `PaymentSettingsModal_dropdown_menu_contain__HeODC`,
	"dropdown_item": `PaymentSettingsModal_dropdown_item__vxXx8`,
	"profile_arrrow_dwn": `PaymentSettingsModal_profile_arrrow_dwn__zMSXS`,
	"dateinputbox1": `PaymentSettingsModal_dateinputbox1__SBNzJ`,
	"modal-content": `PaymentSettingsModal_modal-content__bNvCT`,
	"larg_model": `PaymentSettingsModal_larg_model__Pv6G2`,
	"modal-dialog": `PaymentSettingsModal_modal-dialog__Zvdt+`,
	"modal-header": `PaymentSettingsModal_modal-header__lDLsF`,
	"btn-primary": `PaymentSettingsModal_btn-primary__oRX7t`,
	"form-select": `PaymentSettingsModal_form-select__pjGR+`,
	"CustomTable_tableheadlight__HuHZw": `PaymentSettingsModal_CustomTable_tableheadlight__HuHZw__4dkSt`,
	"CustomTable_tableheaddark__nwqb4": `PaymentSettingsModal_CustomTable_tableheaddark__nwqb4__RMofR`,
	"sectionright": `PaymentSettingsModal_sectionright__0fL2-`,
	"exer_modal_contain": `PaymentSettingsModal_exer_modal_contain__pe0Uc`,
	"active_show_outer": `PaymentSettingsModal_active_show_outer__6GdL+`,
	"active_show_inner": `PaymentSettingsModal_active_show_inner__f5BtO`,
	"act_box_img": `PaymentSettingsModal_act_box_img__dZoo5`,
	"act_box_cnt": `PaymentSettingsModal_act_box_cnt__agVv9`,
	"act_box_bdg": `PaymentSettingsModal_act_box_bdg__wdMtF`,
	"sold": `PaymentSettingsModal_sold__-Ejia`,
	"attent_details": `PaymentSettingsModal_attent_details__cqrjv`,
	"attent_details_inner": `PaymentSettingsModal_attent_details_inner__hVTxB`,
	"attent_details_inner_l": `PaymentSettingsModal_attent_details_inner_l__8wM21`,
	"attent_details_inner_r": `PaymentSettingsModal_attent_details_inner_r__wU8B8`,
	"attent_details_row": `PaymentSettingsModal_attent_details_row__lF0Y2`,
	"attent_details_row_box": `PaymentSettingsModal_attent_details_row_box__hs4Ij`,
	"attent_details_row_last": `PaymentSettingsModal_attent_details_row_last__9QRBD`,
	"interesting_fact": `PaymentSettingsModal_interesting_fact__4I1Eg`,
	"showbox_sec": `PaymentSettingsModal_showbox_sec__K34pu`,
	"show_box_main": `PaymentSettingsModal_show_box_main__m+CVb`,
	"show_box": `PaymentSettingsModal_show_box__63fG2`,
	"no_show_box": `PaymentSettingsModal_no_show_box__9v0Rw`,
	"attent_flex": `PaymentSettingsModal_attent_flex__GVQgP`,
	"pay_modal": `PaymentSettingsModal_pay_modal__dxppb`,
	"pay_modal_hd": `PaymentSettingsModal_pay_modal_hd__-a+GB`,
	"pay_body": `PaymentSettingsModal_pay_body__sadXF`,
	"pay_body_form": `PaymentSettingsModal_pay_body_form__yDCIy`,
	"pay_form_grp": `PaymentSettingsModal_pay_form_grp__0-AvZ`,
	"pay_label": `PaymentSettingsModal_pay_label__gl08h`,
	"pay_input": `PaymentSettingsModal_pay_input__Dorlf`,
	"pay_input_copy": `PaymentSettingsModal_pay_input_copy__IMn3V`,
	"apply_contain": `PaymentSettingsModal_apply_contain__FlUS2`,
	"apply_hd": `PaymentSettingsModal_apply_hd__h3f8s`,
	"flat_amount": `PaymentSettingsModal_flat_amount__9A5us`,
	"percentage_amount": `PaymentSettingsModal_percentage_amount__QTBwT`,
	"both_fee_fields": `PaymentSettingsModal_both_fee_fields__g5nns`,
	"pay_sub_label": `PaymentSettingsModal_pay_sub_label__djIsq`,
	"pay_update_btn": `PaymentSettingsModal_pay_update_btn__6qgoE`,
	"copy_btn": `PaymentSettingsModal_copy_btn__TYkig`,
	"custm_radio": `PaymentSettingsModal_custm_radio__rpcTB`
};
export default ___CSS_LOADER_EXPORT___;
